import React, { FC, ReactNode } from 'react'
import { Wrapper, ImgWrapper, Img, Info } from './styled'

interface ComponentProps {
	children: ReactNode
	imgWebp: string
	imgJpg: string
	styled?: string
	className?: string
	isReverse?: boolean
}

export const ListWithImg: FC<ComponentProps> = ({
	imgWebp,
	imgJpg,
	children,
	className,
	styled = '',
	isReverse = false,
}) => (
	<Wrapper styled={styled}>
		<ImgWrapper className={className} srcSource={imgWebp}>
			<Img src={imgJpg} alt="" />
		</ImgWrapper>
		<Info isReverse={isReverse}>{children}</Info>
	</Wrapper>
)
